//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class DropdownClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param env (optional) 
     * @return Success
     */
    getCompanyCodeDropdownValues(env: Environment | undefined , cancelToken?: CancelToken | undefined): Promise<DropdownDto[]> {
        let url_ = this.baseUrl + "/api/Dropdown/GetCompanyCodeDropdownValues?";
        if (env === null)
            throw new Error("The parameter 'env' cannot be null.");
        else if (env !== undefined)
            url_ += "env=" + encodeURIComponent("" + env) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyCodeDropdownValues(_response);
        });
    }

    protected processGetCompanyCodeDropdownValues(response: AxiosResponse): Promise<DropdownDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DropdownDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DropdownDto[]>(null as any);
    }

    /**
     * @param env (optional) 
     * @param body (optional) 
     * @return Success
     */
    getMessageNameDropdownValues(env: Environment | undefined, body: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<DropdownDto[]> {
        let url_ = this.baseUrl + "/api/Dropdown/GetMessageNameDropdownValues?";
        if (env === null)
            throw new Error("The parameter 'env' cannot be null.");
        else if (env !== undefined)
            url_ += "env=" + encodeURIComponent("" + env) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessageNameDropdownValues(_response);
        });
    }

    protected processGetMessageNameDropdownValues(response: AxiosResponse): Promise<DropdownDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DropdownDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DropdownDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFlowTypeDropdownValues(  cancelToken?: CancelToken | undefined): Promise<DropdownDto[]> {
        let url_ = this.baseUrl + "/api/Dropdown/GetFlowTypeDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlowTypeDropdownValues(_response);
        });
    }

    protected processGetFlowTypeDropdownValues(response: AxiosResponse): Promise<DropdownDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DropdownDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DropdownDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getProcessCodeDropdownValues(  cancelToken?: CancelToken | undefined): Promise<DropdownDto[]> {
        let url_ = this.baseUrl + "/api/Dropdown/GetProcessCodeDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProcessCodeDropdownValues(_response);
        });
    }

    protected processGetProcessCodeDropdownValues(response: AxiosResponse): Promise<DropdownDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DropdownDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DropdownDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFunctionalManagerDropdownValues(  cancelToken?: CancelToken | undefined): Promise<DropdownDto[]> {
        let url_ = this.baseUrl + "/api/Dropdown/GetFunctionalManagerDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFunctionalManagerDropdownValues(_response);
        });
    }

    protected processGetFunctionalManagerDropdownValues(response: AxiosResponse): Promise<DropdownDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DropdownDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DropdownDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSocietyDropdownValues(  cancelToken?: CancelToken | undefined): Promise<DropdownDto[]> {
        let url_ = this.baseUrl + "/api/Dropdown/GetSocietyDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSocietyDropdownValues(_response);
        });
    }

    protected processGetSocietyDropdownValues(response: AxiosResponse): Promise<DropdownDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DropdownDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DropdownDto[]>(null as any);
    }

    /**
     * @return Accepted
     */
    syncWithWebEAIBack(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dropdown/SyncWithWebEAIBack";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncWithWebEAIBack(_response);
        });
    }

    protected processSyncWithWebEAIBack(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getDateOfLastSyncWithWebEAIBack(  cancelToken?: CancelToken | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/api/Dropdown/GetDateOfLastSyncWithWebEAIBack";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDateOfLastSyncWithWebEAIBack(_response);
        });
    }

    protected processGetDateOfLastSyncWithWebEAIBack(response: AxiosResponse): Promise<Date> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return Promise.resolve<Date>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date>(null as any);
    }
}

export class FilterClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateFilter(body: FilterValueDto | undefined , cancelToken?: CancelToken | undefined): Promise<FilterValueDto> {
        let url_ = this.baseUrl + "/api/Filter/CreateOrUpdateFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateFilter(_response);
        });
    }

    protected processCreateOrUpdateFilter(response: AxiosResponse): Promise<FilterValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterValueDto.fromJS(resultData200);
            return Promise.resolve<FilterValueDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterValueDto>(null as any);
    }

    /**
     * @return Success
     */
    getMyFilter(  cancelToken?: CancelToken | undefined): Promise<FilterValueDto[]> {
        let url_ = this.baseUrl + "/api/Filter/GetMyFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyFilter(_response);
        });
    }

    protected processGetMyFilter(response: AxiosResponse): Promise<FilterValueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FilterValueDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterValueDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Accepted
     */
    deleteFilter(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Filter/DeleteFilter?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFilter(_response);
        });
    }

    protected processDeleteFilter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FlowListClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getValuesFlowList(body: FlowListFilter | undefined , cancelToken?: CancelToken | undefined): Promise<FlowListPagedList> {
        let url_ = this.baseUrl + "/api/FlowList/GetValuesFlowList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetValuesFlowList(_response);
        });
    }

    protected processGetValuesFlowList(response: AxiosResponse): Promise<FlowListPagedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlowListPagedList.fromJS(resultData200);
            return Promise.resolve<FlowListPagedList>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlowListPagedList>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportToCSV(body: string[] | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FlowList/ExportToCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToCSV(_response);
        });
    }

    protected processExportToCSV(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class KPIClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getKPIFlowsLastYear(  cancelToken?: CancelToken | undefined): Promise<KPIFlowsLastMonthDtoPagedList> {
        let url_ = this.baseUrl + "/api/KPI/GetKPIFlowsLastYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKPIFlowsLastYear(_response);
        });
    }

    protected processGetKPIFlowsLastYear(response: AxiosResponse): Promise<KPIFlowsLastMonthDtoPagedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KPIFlowsLastMonthDtoPagedList.fromJS(resultData200);
            return Promise.resolve<KPIFlowsLastMonthDtoPagedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KPIFlowsLastMonthDtoPagedList>(null as any);
    }

    /**
     * @return Success
     */
    getKPIFlowsLastMonth(  cancelToken?: CancelToken | undefined): Promise<KPIFlowsLastMonthDtoPagedList> {
        let url_ = this.baseUrl + "/api/KPI/GetKPIFlowsLastMonth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKPIFlowsLastMonth(_response);
        });
    }

    protected processGetKPIFlowsLastMonth(response: AxiosResponse): Promise<KPIFlowsLastMonthDtoPagedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KPIFlowsLastMonthDtoPagedList.fromJS(resultData200);
            return Promise.resolve<KPIFlowsLastMonthDtoPagedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KPIFlowsLastMonthDtoPagedList>(null as any);
    }

    /**
     * @param env (optional) 
     * @return Success
     */
    getKPIStatusLastMonth(env: string | undefined , cancelToken?: CancelToken | undefined): Promise<KPIStatusLastYearPagedList> {
        let url_ = this.baseUrl + "/api/KPI/GetKPIStatusLastMonth?";
        if (env === null)
            throw new Error("The parameter 'env' cannot be null.");
        else if (env !== undefined)
            url_ += "env=" + encodeURIComponent("" + env) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKPIStatusLastMonth(_response);
        });
    }

    protected processGetKPIStatusLastMonth(response: AxiosResponse): Promise<KPIStatusLastYearPagedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KPIStatusLastYearPagedList.fromJS(resultData200);
            return Promise.resolve<KPIStatusLastYearPagedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KPIStatusLastYearPagedList>(null as any);
    }

    /**
     * @param env (optional) 
     * @return Success
     */
    getKPIStatusLastYear(env: string | undefined , cancelToken?: CancelToken | undefined): Promise<KPIStatusLastYearPagedList> {
        let url_ = this.baseUrl + "/api/KPI/GetKPIStatusLastYear?";
        if (env === null)
            throw new Error("The parameter 'env' cannot be null.");
        else if (env !== undefined)
            url_ += "env=" + encodeURIComponent("" + env) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKPIStatusLastYear(_response);
        });
    }

    protected processGetKPIStatusLastYear(response: AxiosResponse): Promise<KPIStatusLastYearPagedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KPIStatusLastYearPagedList.fromJS(resultData200);
            return Promise.resolve<KPIStatusLastYearPagedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KPIStatusLastYearPagedList>(null as any);
    }
}

export class PermissionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getPermissions(  cancelToken?: CancelToken | undefined): Promise<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/Permission/GetPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: AxiosResponse): Promise<PermissionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PermissionDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionDto[]>(null as any);
    }
}

export class RoleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getRoles(  cancelToken?: CancelToken | undefined): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sortBy (optional) 
     * @param ascending (optional) 
     * @return Success
     */
    getRolesForManagement(filter: string | undefined, sortBy: string | undefined, pageIndex: number, pageSize: number, ascending: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDtoPagedListResultDto> {
        let url_ = this.baseUrl + "/api/Role/GetRolesForManagement?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (ascending === null)
            throw new Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolesForManagement(_response);
        });
    }

    protected processGetRolesForManagement(response: AxiosResponse): Promise<RoleDtoPagedListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoPagedListResultDto.fromJS(resultData200);
            return Promise.resolve<RoleDtoPagedListResultDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoPagedListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: RoleDto | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateRole(_response);
        });
    }

    protected processCreateOrUpdateRole(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Accepted
     */
    deleteRole(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRole(_response);
        });
    }

    protected processDeleteRole(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
                result202 = resultData202 !== undefined ? resultData202 : <any>null;
    
            return Promise.resolve<boolean>(result202);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    authorization(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthorization(_response);
        });
    }

    protected processAuthorization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthorizationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    testAuthorization(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authorization/TestAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestAuthorization(_response);
        });
    }

    protected processTestAuthorization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SamlClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param returnUrl (optional) 
     * @return Success
     */
    initiateSingleSignOn(returnUrl: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Saml/InitiateSingleSignOn?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitiateSingleSignOn(_response);
        });
    }

    protected processInitiateSingleSignOn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param returnUrl (optional) 
     * @return Success
     */
    callback(returnUrl: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Saml/Callback?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCallback(_response);
        });
    }

    protected processCallback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUsers(body: PagedListInput | undefined , cancelToken?: CancelToken | undefined): Promise<UserItemTablePagedList> {
        let url_ = this.baseUrl + "/api/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UserItemTablePagedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserItemTablePagedList.fromJS(resultData200);
            return Promise.resolve<UserItemTablePagedList>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserItemTablePagedList>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: UserItemTable | undefined , cancelToken?: CancelToken | undefined): Promise<UserItemTable> {
        let url_ = this.baseUrl + "/api/User/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<UserItemTable> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserItemTable.fromJS(resultData200);
            return Promise.resolve<UserItemTable>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserItemTable>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentUser(  cancelToken?: CancelToken | undefined): Promise<UserDto2> {
        let url_ = this.baseUrl + "/api/User/GetCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<UserDto2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto2.fromJS(resultData200);
            return Promise.resolve<UserDto2>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto2>(null as any);
    }
}

export class DropdownDto implements IDropdownDto {
    id?: string;
    name?: string | undefined;
    type?: DropdownType;

    constructor(data?: IDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IDropdownDto {
    id?: string;
    name?: string | undefined;
    type?: DropdownType;
}

export enum DropdownType {
    CompanyCode = "CompanyCode",
    MessageName = "MessageName",
    FlowType = "FlowType",
    Domain = "Domain",
    ProcessCode = "ProcessCode",
    Society = "Society",
    FunctionalManager = "FunctionalManager",
}

export enum Environment {
    Dev = "Dev",
    Staging = "Staging",
    Prod = "Prod",
}

export class EventDto implements IEventDto {
    id?: string;
    eventType?: string | undefined;
    userId?: string | undefined;
    start?: Date;
    end?: Date;
    comment?: string | undefined;
    updateDate?: Date;

    constructor(data?: IEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventType = _data["eventType"];
            this.userId = _data["userId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventType"] = this.eventType;
        data["userId"] = this.userId;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEventDto {
    id?: string;
    eventType?: string | undefined;
    userId?: string | undefined;
    start?: Date;
    end?: Date;
    comment?: string | undefined;
    updateDate?: Date;
}

export class FilterValueDto implements IFilterValueDto {
    id?: string;
    filterName!: string;
    companyFrom?: string[] | undefined;
    companyTo?: string[] | undefined;
    messageName?: string[] | undefined;
    flowType?: string[] | undefined;
    dateTimeFrom?: Date | undefined;
    dateTimeTo?: Date | undefined;
    timezone?: string | undefined;
    flowStatusList?: FlowStatus[] | undefined;
    fileName?: string | undefined;
    serverName?: string | undefined;
    functionalKey?: string | undefined;
    technicalKey?: string | undefined;
    environnement!: Environment;

    constructor(data?: IFilterValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filterName = _data["filterName"];
            if (Array.isArray(_data["companyFrom"])) {
                this.companyFrom = [] as any;
                for (let item of _data["companyFrom"])
                    this.companyFrom!.push(item);
            }
            if (Array.isArray(_data["companyTo"])) {
                this.companyTo = [] as any;
                for (let item of _data["companyTo"])
                    this.companyTo!.push(item);
            }
            if (Array.isArray(_data["messageName"])) {
                this.messageName = [] as any;
                for (let item of _data["messageName"])
                    this.messageName!.push(item);
            }
            if (Array.isArray(_data["flowType"])) {
                this.flowType = [] as any;
                for (let item of _data["flowType"])
                    this.flowType!.push(item);
            }
            this.dateTimeFrom = _data["dateTimeFrom"] ? new Date(_data["dateTimeFrom"].toString()) : <any>undefined;
            this.dateTimeTo = _data["dateTimeTo"] ? new Date(_data["dateTimeTo"].toString()) : <any>undefined;
            this.timezone = _data["timezone"];
            if (Array.isArray(_data["flowStatusList"])) {
                this.flowStatusList = [] as any;
                for (let item of _data["flowStatusList"])
                    this.flowStatusList!.push(item);
            }
            this.fileName = _data["fileName"];
            this.serverName = _data["serverName"];
            this.functionalKey = _data["functionalKey"];
            this.technicalKey = _data["technicalKey"];
            this.environnement = _data["environnement"];
        }
    }

    static fromJS(data: any): FilterValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filterName"] = this.filterName;
        if (Array.isArray(this.companyFrom)) {
            data["companyFrom"] = [];
            for (let item of this.companyFrom)
                data["companyFrom"].push(item);
        }
        if (Array.isArray(this.companyTo)) {
            data["companyTo"] = [];
            for (let item of this.companyTo)
                data["companyTo"].push(item);
        }
        if (Array.isArray(this.messageName)) {
            data["messageName"] = [];
            for (let item of this.messageName)
                data["messageName"].push(item);
        }
        if (Array.isArray(this.flowType)) {
            data["flowType"] = [];
            for (let item of this.flowType)
                data["flowType"].push(item);
        }
        data["dateTimeFrom"] = this.dateTimeFrom ? this.dateTimeFrom.toISOString() : <any>undefined;
        data["dateTimeTo"] = this.dateTimeTo ? this.dateTimeTo.toISOString() : <any>undefined;
        data["timezone"] = this.timezone;
        if (Array.isArray(this.flowStatusList)) {
            data["flowStatusList"] = [];
            for (let item of this.flowStatusList)
                data["flowStatusList"].push(item);
        }
        data["fileName"] = this.fileName;
        data["serverName"] = this.serverName;
        data["functionalKey"] = this.functionalKey;
        data["technicalKey"] = this.technicalKey;
        data["environnement"] = this.environnement;
        return data;
    }
}

export interface IFilterValueDto {
    id?: string;
    filterName: string;
    companyFrom?: string[] | undefined;
    companyTo?: string[] | undefined;
    messageName?: string[] | undefined;
    flowType?: string[] | undefined;
    dateTimeFrom?: Date | undefined;
    dateTimeTo?: Date | undefined;
    timezone?: string | undefined;
    flowStatusList?: FlowStatus[] | undefined;
    fileName?: string | undefined;
    serverName?: string | undefined;
    functionalKey?: string | undefined;
    technicalKey?: string | undefined;
    environnement: Environment;
}

export class FlowList implements IFlowList {
    createDate?: Date;
    updateDate?: Date;
    createUserId?: string;
    updateUserId?: string;
    id?: string;
    rowType?: string | undefined;
    domain?: string | undefined;
    processCode?: string | undefined;
    projectCode?: string | undefined;
    flowMessageNumber?: string | undefined;
    messageName?: string | undefined;
    messageFunctionnalContent?: string | undefined;
    messageFunctionnalDescription?: string | undefined;
    flowParticularities?: string | undefined;
    flowTransferTool?: string | undefined;
    isCritical?: string | undefined;
    flowCriticality?: string | undefined;
    isSensible?: string | undefined;
    flowFunctionnalResponsible?: string | undefined;
    flowTestsDate?: string | undefined;
    flowGoLiveDate?: string | undefined;
    commercialOrganisation?: string | undefined;
    activity?: string | undefined;
    distributionChannel?: string | undefined;
    orderType?: string | undefined;
    inSocietyCode?: string | undefined;
    inSocietyName?: string | undefined;
    inCustomerCode?: string | undefined;
    inSupplierCode?: string | undefined;
    inSystem?: string | undefined;
    inFormat?: string | undefined;
    inPatternFileName?: string | undefined;
    inFileStructure?: string | undefined;
    inFrequency?: string | undefined;
    inTreatments?: string | undefined;
    inIsSaas?: string | undefined;
    inIsSecured?: string | undefined;
    inTechnicalContact?: string | undefined;
    inDevApplication?: string | undefined;
    inDevType?: string | undefined;
    inDevServer?: string | undefined;
    inDevDirectory?: string | undefined;
    inTestApplication?: string | undefined;
    inTestType?: string | undefined;
    inTestServer?: string | undefined;
    inTestDirectory?: string | undefined;
    inProdApplication?: string | undefined;
    inProdType?: string | undefined;
    inProdServer?: string | undefined;
    inProdDirectory?: string | undefined;
    outSocietyCode?: string | undefined;
    outSocietyName?: string | undefined;
    outCustomerCode?: string | undefined;
    outSupplierCode?: string | undefined;
    outSystem?: string | undefined;
    outFormat?: string | undefined;
    outPatternFileName?: string | undefined;
    outFileStructure?: string | undefined;
    outFrequency?: string | undefined;
    outIsSaas?: string | undefined;
    outIsSecured?: string | undefined;
    outTechnicalContact?: string | undefined;
    outDevApplication?: string | undefined;
    outDevType?: string | undefined;
    outDevServer?: string | undefined;
    outDevDirectory?: string | undefined;
    outTestApplication?: string | undefined;
    outTestType?: string | undefined;
    outTestServer?: string | undefined;
    outTestDirectory?: string | undefined;
    outProdApplication?: string | undefined;
    outProdType?: string | undefined;
    outProdServer?: string | undefined;
    outProdDirectory?: string | undefined;
    solutionName?: string | undefined;
    rpoName?: string | undefined;
    rloName?: string | undefined;
    rloOpenFrameTime?: string | undefined;
    spoName?: string | undefined;
    spgName?: string | undefined;
    spoOpenFrameTime?: string | undefined;
    interchange?: string | undefined;
    devFile?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IFlowList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.updateUserId = _data["updateUserId"];
            this.id = _data["id"];
            this.rowType = _data["rowType"];
            this.domain = _data["domain"];
            this.processCode = _data["processCode"];
            this.projectCode = _data["projectCode"];
            this.flowMessageNumber = _data["flowMessageNumber"];
            this.messageName = _data["messageName"];
            this.messageFunctionnalContent = _data["messageFunctionnalContent"];
            this.messageFunctionnalDescription = _data["messageFunctionnalDescription"];
            this.flowParticularities = _data["flowParticularities"];
            this.flowTransferTool = _data["flowTransferTool"];
            this.isCritical = _data["isCritical"];
            this.flowCriticality = _data["flowCriticality"];
            this.isSensible = _data["isSensible"];
            this.flowFunctionnalResponsible = _data["flowFunctionnalResponsible"];
            this.flowTestsDate = _data["flowTestsDate"];
            this.flowGoLiveDate = _data["flowGoLiveDate"];
            this.commercialOrganisation = _data["commercialOrganisation"];
            this.activity = _data["activity"];
            this.distributionChannel = _data["distributionChannel"];
            this.orderType = _data["orderType"];
            this.inSocietyCode = _data["inSocietyCode"];
            this.inSocietyName = _data["inSocietyName"];
            this.inCustomerCode = _data["inCustomerCode"];
            this.inSupplierCode = _data["inSupplierCode"];
            this.inSystem = _data["inSystem"];
            this.inFormat = _data["inFormat"];
            this.inPatternFileName = _data["inPatternFileName"];
            this.inFileStructure = _data["inFileStructure"];
            this.inFrequency = _data["inFrequency"];
            this.inTreatments = _data["inTreatments"];
            this.inIsSaas = _data["inIsSaas"];
            this.inIsSecured = _data["inIsSecured"];
            this.inTechnicalContact = _data["inTechnicalContact"];
            this.inDevApplication = _data["inDevApplication"];
            this.inDevType = _data["inDevType"];
            this.inDevServer = _data["inDevServer"];
            this.inDevDirectory = _data["inDevDirectory"];
            this.inTestApplication = _data["inTestApplication"];
            this.inTestType = _data["inTestType"];
            this.inTestServer = _data["inTestServer"];
            this.inTestDirectory = _data["inTestDirectory"];
            this.inProdApplication = _data["inProdApplication"];
            this.inProdType = _data["inProdType"];
            this.inProdServer = _data["inProdServer"];
            this.inProdDirectory = _data["inProdDirectory"];
            this.outSocietyCode = _data["outSocietyCode"];
            this.outSocietyName = _data["outSocietyName"];
            this.outCustomerCode = _data["outCustomerCode"];
            this.outSupplierCode = _data["outSupplierCode"];
            this.outSystem = _data["outSystem"];
            this.outFormat = _data["outFormat"];
            this.outPatternFileName = _data["outPatternFileName"];
            this.outFileStructure = _data["outFileStructure"];
            this.outFrequency = _data["outFrequency"];
            this.outIsSaas = _data["outIsSaas"];
            this.outIsSecured = _data["outIsSecured"];
            this.outTechnicalContact = _data["outTechnicalContact"];
            this.outDevApplication = _data["outDevApplication"];
            this.outDevType = _data["outDevType"];
            this.outDevServer = _data["outDevServer"];
            this.outDevDirectory = _data["outDevDirectory"];
            this.outTestApplication = _data["outTestApplication"];
            this.outTestType = _data["outTestType"];
            this.outTestServer = _data["outTestServer"];
            this.outTestDirectory = _data["outTestDirectory"];
            this.outProdApplication = _data["outProdApplication"];
            this.outProdType = _data["outProdType"];
            this.outProdServer = _data["outProdServer"];
            this.outProdDirectory = _data["outProdDirectory"];
            this.solutionName = _data["solutionName"];
            this.rpoName = _data["rpoName"];
            this.rloName = _data["rloName"];
            this.rloOpenFrameTime = _data["rloOpenFrameTime"];
            this.spoName = _data["spoName"];
            this.spgName = _data["spgName"];
            this.spoOpenFrameTime = _data["spoOpenFrameTime"];
            this.interchange = _data["interchange"];
            this.devFile = _data["devFile"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): FlowList {
        data = typeof data === 'object' ? data : {};
        let result = new FlowList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["updateUserId"] = this.updateUserId;
        data["id"] = this.id;
        data["rowType"] = this.rowType;
        data["domain"] = this.domain;
        data["processCode"] = this.processCode;
        data["projectCode"] = this.projectCode;
        data["flowMessageNumber"] = this.flowMessageNumber;
        data["messageName"] = this.messageName;
        data["messageFunctionnalContent"] = this.messageFunctionnalContent;
        data["messageFunctionnalDescription"] = this.messageFunctionnalDescription;
        data["flowParticularities"] = this.flowParticularities;
        data["flowTransferTool"] = this.flowTransferTool;
        data["isCritical"] = this.isCritical;
        data["flowCriticality"] = this.flowCriticality;
        data["isSensible"] = this.isSensible;
        data["flowFunctionnalResponsible"] = this.flowFunctionnalResponsible;
        data["flowTestsDate"] = this.flowTestsDate;
        data["flowGoLiveDate"] = this.flowGoLiveDate;
        data["commercialOrganisation"] = this.commercialOrganisation;
        data["activity"] = this.activity;
        data["distributionChannel"] = this.distributionChannel;
        data["orderType"] = this.orderType;
        data["inSocietyCode"] = this.inSocietyCode;
        data["inSocietyName"] = this.inSocietyName;
        data["inCustomerCode"] = this.inCustomerCode;
        data["inSupplierCode"] = this.inSupplierCode;
        data["inSystem"] = this.inSystem;
        data["inFormat"] = this.inFormat;
        data["inPatternFileName"] = this.inPatternFileName;
        data["inFileStructure"] = this.inFileStructure;
        data["inFrequency"] = this.inFrequency;
        data["inTreatments"] = this.inTreatments;
        data["inIsSaas"] = this.inIsSaas;
        data["inIsSecured"] = this.inIsSecured;
        data["inTechnicalContact"] = this.inTechnicalContact;
        data["inDevApplication"] = this.inDevApplication;
        data["inDevType"] = this.inDevType;
        data["inDevServer"] = this.inDevServer;
        data["inDevDirectory"] = this.inDevDirectory;
        data["inTestApplication"] = this.inTestApplication;
        data["inTestType"] = this.inTestType;
        data["inTestServer"] = this.inTestServer;
        data["inTestDirectory"] = this.inTestDirectory;
        data["inProdApplication"] = this.inProdApplication;
        data["inProdType"] = this.inProdType;
        data["inProdServer"] = this.inProdServer;
        data["inProdDirectory"] = this.inProdDirectory;
        data["outSocietyCode"] = this.outSocietyCode;
        data["outSocietyName"] = this.outSocietyName;
        data["outCustomerCode"] = this.outCustomerCode;
        data["outSupplierCode"] = this.outSupplierCode;
        data["outSystem"] = this.outSystem;
        data["outFormat"] = this.outFormat;
        data["outPatternFileName"] = this.outPatternFileName;
        data["outFileStructure"] = this.outFileStructure;
        data["outFrequency"] = this.outFrequency;
        data["outIsSaas"] = this.outIsSaas;
        data["outIsSecured"] = this.outIsSecured;
        data["outTechnicalContact"] = this.outTechnicalContact;
        data["outDevApplication"] = this.outDevApplication;
        data["outDevType"] = this.outDevType;
        data["outDevServer"] = this.outDevServer;
        data["outDevDirectory"] = this.outDevDirectory;
        data["outTestApplication"] = this.outTestApplication;
        data["outTestType"] = this.outTestType;
        data["outTestServer"] = this.outTestServer;
        data["outTestDirectory"] = this.outTestDirectory;
        data["outProdApplication"] = this.outProdApplication;
        data["outProdType"] = this.outProdType;
        data["outProdServer"] = this.outProdServer;
        data["outProdDirectory"] = this.outProdDirectory;
        data["solutionName"] = this.solutionName;
        data["rpoName"] = this.rpoName;
        data["rloName"] = this.rloName;
        data["rloOpenFrameTime"] = this.rloOpenFrameTime;
        data["spoName"] = this.spoName;
        data["spgName"] = this.spgName;
        data["spoOpenFrameTime"] = this.spoOpenFrameTime;
        data["interchange"] = this.interchange;
        data["devFile"] = this.devFile;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IFlowList {
    createDate?: Date;
    updateDate?: Date;
    createUserId?: string;
    updateUserId?: string;
    id?: string;
    rowType?: string | undefined;
    domain?: string | undefined;
    processCode?: string | undefined;
    projectCode?: string | undefined;
    flowMessageNumber?: string | undefined;
    messageName?: string | undefined;
    messageFunctionnalContent?: string | undefined;
    messageFunctionnalDescription?: string | undefined;
    flowParticularities?: string | undefined;
    flowTransferTool?: string | undefined;
    isCritical?: string | undefined;
    flowCriticality?: string | undefined;
    isSensible?: string | undefined;
    flowFunctionnalResponsible?: string | undefined;
    flowTestsDate?: string | undefined;
    flowGoLiveDate?: string | undefined;
    commercialOrganisation?: string | undefined;
    activity?: string | undefined;
    distributionChannel?: string | undefined;
    orderType?: string | undefined;
    inSocietyCode?: string | undefined;
    inSocietyName?: string | undefined;
    inCustomerCode?: string | undefined;
    inSupplierCode?: string | undefined;
    inSystem?: string | undefined;
    inFormat?: string | undefined;
    inPatternFileName?: string | undefined;
    inFileStructure?: string | undefined;
    inFrequency?: string | undefined;
    inTreatments?: string | undefined;
    inIsSaas?: string | undefined;
    inIsSecured?: string | undefined;
    inTechnicalContact?: string | undefined;
    inDevApplication?: string | undefined;
    inDevType?: string | undefined;
    inDevServer?: string | undefined;
    inDevDirectory?: string | undefined;
    inTestApplication?: string | undefined;
    inTestType?: string | undefined;
    inTestServer?: string | undefined;
    inTestDirectory?: string | undefined;
    inProdApplication?: string | undefined;
    inProdType?: string | undefined;
    inProdServer?: string | undefined;
    inProdDirectory?: string | undefined;
    outSocietyCode?: string | undefined;
    outSocietyName?: string | undefined;
    outCustomerCode?: string | undefined;
    outSupplierCode?: string | undefined;
    outSystem?: string | undefined;
    outFormat?: string | undefined;
    outPatternFileName?: string | undefined;
    outFileStructure?: string | undefined;
    outFrequency?: string | undefined;
    outIsSaas?: string | undefined;
    outIsSecured?: string | undefined;
    outTechnicalContact?: string | undefined;
    outDevApplication?: string | undefined;
    outDevType?: string | undefined;
    outDevServer?: string | undefined;
    outDevDirectory?: string | undefined;
    outTestApplication?: string | undefined;
    outTestType?: string | undefined;
    outTestServer?: string | undefined;
    outTestDirectory?: string | undefined;
    outProdApplication?: string | undefined;
    outProdType?: string | undefined;
    outProdServer?: string | undefined;
    outProdDirectory?: string | undefined;
    solutionName?: string | undefined;
    rpoName?: string | undefined;
    rloName?: string | undefined;
    rloOpenFrameTime?: string | undefined;
    spoName?: string | undefined;
    spgName?: string | undefined;
    spoOpenFrameTime?: string | undefined;
    interchange?: string | undefined;
    devFile?: string | undefined;
    comments?: string | undefined;
}

export class FlowListFilter implements IFlowListFilter {
    filter?: string | undefined;
    sortBy?: string | undefined;
    pageIndex!: number;
    pageSize!: number;
    ascending?: boolean;
    isCriticalFlow?: boolean;
    domain?: string | undefined;
    processCode?: string[] | undefined;
    messageName?: string[] | undefined;
    fromSociety?: string[] | undefined;
    toSociety?: string[] | undefined;
    functionalManager?: string | undefined;
    fileName?: string | undefined;
    serverName?: string | undefined;
    functionalKey?: string | undefined;
    technicalKey?: string | undefined;

    constructor(data?: IFlowListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sortBy = _data["sortBy"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.ascending = _data["ascending"];
            this.isCriticalFlow = _data["isCriticalFlow"];
            this.domain = _data["domain"];
            if (Array.isArray(_data["processCode"])) {
                this.processCode = [] as any;
                for (let item of _data["processCode"])
                    this.processCode!.push(item);
            }
            if (Array.isArray(_data["messageName"])) {
                this.messageName = [] as any;
                for (let item of _data["messageName"])
                    this.messageName!.push(item);
            }
            if (Array.isArray(_data["fromSociety"])) {
                this.fromSociety = [] as any;
                for (let item of _data["fromSociety"])
                    this.fromSociety!.push(item);
            }
            if (Array.isArray(_data["toSociety"])) {
                this.toSociety = [] as any;
                for (let item of _data["toSociety"])
                    this.toSociety!.push(item);
            }
            this.functionalManager = _data["functionalManager"];
            this.fileName = _data["fileName"];
            this.serverName = _data["serverName"];
            this.functionalKey = _data["functionalKey"];
            this.technicalKey = _data["technicalKey"];
        }
    }

    static fromJS(data: any): FlowListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new FlowListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sortBy"] = this.sortBy;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["ascending"] = this.ascending;
        data["isCriticalFlow"] = this.isCriticalFlow;
        data["domain"] = this.domain;
        if (Array.isArray(this.processCode)) {
            data["processCode"] = [];
            for (let item of this.processCode)
                data["processCode"].push(item);
        }
        if (Array.isArray(this.messageName)) {
            data["messageName"] = [];
            for (let item of this.messageName)
                data["messageName"].push(item);
        }
        if (Array.isArray(this.fromSociety)) {
            data["fromSociety"] = [];
            for (let item of this.fromSociety)
                data["fromSociety"].push(item);
        }
        if (Array.isArray(this.toSociety)) {
            data["toSociety"] = [];
            for (let item of this.toSociety)
                data["toSociety"].push(item);
        }
        data["functionalManager"] = this.functionalManager;
        data["fileName"] = this.fileName;
        data["serverName"] = this.serverName;
        data["functionalKey"] = this.functionalKey;
        data["technicalKey"] = this.technicalKey;
        return data;
    }
}

export interface IFlowListFilter {
    filter?: string | undefined;
    sortBy?: string | undefined;
    pageIndex: number;
    pageSize: number;
    ascending?: boolean;
    isCriticalFlow?: boolean;
    domain?: string | undefined;
    processCode?: string[] | undefined;
    messageName?: string[] | undefined;
    fromSociety?: string[] | undefined;
    toSociety?: string[] | undefined;
    functionalManager?: string | undefined;
    fileName?: string | undefined;
    serverName?: string | undefined;
    functionalKey?: string | undefined;
    technicalKey?: string | undefined;
}

export class FlowListPagedList implements IFlowListPagedList {
    totalCount!: number;
    items!: FlowList[];

    constructor(data?: IFlowListPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlowList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlowListPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new FlowListPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlowListPagedList {
    totalCount: number;
    items: FlowList[];
}

export enum FlowStatus {
    Failed = "Failed",
    Progress = "In progress",
    Completed = "Completed",
}

export class KPIFlowsLastMonthDto implements IKPIFlowsLastMonthDto {
    id?: string;
    day?: string | undefined;
    month?: string | undefined;
    year?: string | undefined;
    amount?: number;

    constructor(data?: IKPIFlowsLastMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.day = _data["day"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): KPIFlowsLastMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new KPIFlowsLastMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["day"] = this.day;
        data["month"] = this.month;
        data["year"] = this.year;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IKPIFlowsLastMonthDto {
    id?: string;
    day?: string | undefined;
    month?: string | undefined;
    year?: string | undefined;
    amount?: number;
}

export class KPIFlowsLastMonthDtoPagedList implements IKPIFlowsLastMonthDtoPagedList {
    totalCount!: number;
    items!: KPIFlowsLastMonthDto[];

    constructor(data?: IKPIFlowsLastMonthDtoPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KPIFlowsLastMonthDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KPIFlowsLastMonthDtoPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new KPIFlowsLastMonthDtoPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKPIFlowsLastMonthDtoPagedList {
    totalCount: number;
    items: KPIFlowsLastMonthDto[];
}

export class KPIStatusLastYear implements IKPIStatusLastYear {
    day?: string | undefined;
    month?: string | undefined;
    year?: string | undefined;
    env?: string | undefined;
    completed?: number;
    inProgress?: number;
    errors?: number;

    constructor(data?: IKPIStatusLastYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.env = _data["env"];
            this.completed = _data["completed"];
            this.inProgress = _data["inProgress"];
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): KPIStatusLastYear {
        data = typeof data === 'object' ? data : {};
        let result = new KPIStatusLastYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["month"] = this.month;
        data["year"] = this.year;
        data["env"] = this.env;
        data["completed"] = this.completed;
        data["inProgress"] = this.inProgress;
        data["errors"] = this.errors;
        return data;
    }
}

export interface IKPIStatusLastYear {
    day?: string | undefined;
    month?: string | undefined;
    year?: string | undefined;
    env?: string | undefined;
    completed?: number;
    inProgress?: number;
    errors?: number;
}

export class KPIStatusLastYearPagedList implements IKPIStatusLastYearPagedList {
    totalCount!: number;
    items!: KPIStatusLastYear[];

    constructor(data?: IKPIStatusLastYearPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KPIStatusLastYear.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KPIStatusLastYearPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new KPIStatusLastYearPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKPIStatusLastYearPagedList {
    totalCount: number;
    items: KPIStatusLastYear[];
}

export class PagedListInput implements IPagedListInput {
    filter?: string | undefined;
    sortBy?: string | undefined;
    pageIndex!: number;
    pageSize!: number;
    ascending?: boolean;

    constructor(data?: IPagedListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sortBy = _data["sortBy"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.ascending = _data["ascending"];
        }
    }

    static fromJS(data: any): PagedListInput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sortBy"] = this.sortBy;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["ascending"] = this.ascending;
        return data;
    }
}

export interface IPagedListInput {
    filter?: string | undefined;
    sortBy?: string | undefined;
    pageIndex: number;
    pageSize: number;
    ascending?: boolean;
}

export class PermissionDto implements IPermissionDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPermissionDto {
    id?: string;
    name?: string | undefined;
}

export class RoleDto implements IRoleDto {
    id?: string;
    name?: string | undefined;
    isSystemDefault?: boolean;
    permissions?: PermissionDto[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isSystemDefault = _data["isSystemDefault"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isSystemDefault"] = this.isSystemDefault;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleDto {
    id?: string;
    name?: string | undefined;
    isSystemDefault?: boolean;
    permissions?: PermissionDto[] | undefined;
}

export class RoleDtoPagedList implements IRoleDtoPagedList {
    totalCount!: number;
    items!: RoleDto[];

    constructor(data?: IRoleDtoPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleDtoPagedList {
    totalCount: number;
    items: RoleDto[];
}

export class RoleDtoPagedListResultDto implements IRoleDtoPagedListResultDto {
    data?: RoleDtoPagedList;
    succeeded?: boolean;

    constructor(data?: IRoleDtoPagedListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RoleDtoPagedList.fromJS(_data["data"]) : <any>undefined;
            this.succeeded = _data["succeeded"];
        }
    }

    static fromJS(data: any): RoleDtoPagedListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["succeeded"] = this.succeeded;
        return data;
    }
}

export interface IRoleDtoPagedListResultDto {
    data?: RoleDtoPagedList;
    succeeded?: boolean;
}

export class UserDto2 implements IUserDto2 {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    isUpdated?: boolean;
    roleName?: string | undefined;
    permissions?: string[] | undefined;
    events?: EventDto[] | undefined;

    constructor(data?: IUserDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.isUpdated = _data["isUpdated"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(EventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["isUpdated"] = this.isUpdated;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDto2 {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    isUpdated?: boolean;
    roleName?: string | undefined;
    permissions?: string[] | undefined;
    events?: EventDto[] | undefined;
}

export class UserItemTable implements IUserItemTable {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    roleId?: string;

    constructor(data?: IUserItemTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserItemTable {
        data = typeof data === 'object' ? data : {};
        let result = new UserItemTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IUserItemTable {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    roleId?: string;
}

export class UserItemTablePagedList implements IUserItemTablePagedList {
    totalCount!: number;
    items!: UserItemTable[];

    constructor(data?: IUserItemTablePagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserItemTable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserItemTablePagedList {
        data = typeof data === 'object' ? data : {};
        let result = new UserItemTablePagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserItemTablePagedList {
    totalCount: number;
    items: UserItemTable[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}